import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Projectcolors from "../Utils/Colors";
import { baseURL } from "../Config/config";
import { Link, Typography } from "@mui/material";
import Divider from "@mui/material/Divider";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { Button } from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Alert } from "@mui/material";
import { Paper } from "@mui/material";
import TextField from "@mui/material/TextField";
import Input from "@mui/material/Input";
import FilledInput from "@mui/material/FilledInput";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputAdornment from "@mui/material/InputAdornment";
import CircularProgress from "@mui/material/CircularProgress";
import GlobalLoader from "./CommonC/GlobalLoader";
import Tooltip from "@mui/material/Tooltip";
import model from "../images/model.png";
import Arrow from "../images/arrow.png";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import InfoIcon from "@mui/icons-material/Info";
import LinearProgress from '@mui/material/LinearProgress';
import PropTypes from 'prop-types';
import axios from "axios";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";

function LinearProgressWithLabel(props) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Box sx={{ width: '100%', mr: 1 }}>
        <LinearProgress variant="determinate" {...props} />
      </Box>
      <Box sx={{ minWidth: 35 }}>
        <Typography variant="body2"  sx={{fontSize:14}} color="text.secondary">{`${Math.round(
          props.value,
        )}%`}</Typography>
      </Box>
    </Box>
  );
}

LinearProgressWithLabel.propTypes = {
  /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */
  value: PropTypes.number.isRequired,
};



function Forecasting(props) {
  const [independent, setIndependent] = React.useState([]);
  const [dependent, setDependent] = React.useState([]);
  const [count, setCount] = React.useState([]);
  const [dependentalgo, setDependentAlgo] = React.useState([]);
  const [progress, setProgress] = React.useState(0);
  const [algorithm, setAlgorithm] = React.useState([
    "ar",
    "arima",
    "sarimax",
    "es",
    "prophet",
    "cnnlstm"
  ]);

  const [algorithmshort, setAlgorithmshort] = React.useState([
    "AR",
    "ARIMA",
    "SARIMAX",
    "ES",
    "PROPHET",
    "CNNLSTM"
  ]);

  const [index, setIndex] = React.useState();
  const [unitsin, setunitsin] = React.useState([]);
  const [unitsde, setunitsde] = React.useState([]);
  const [trained, setTrained] = React.useState(false);
  const [test, setTest] = React.useState(80);
  const [htest, sethTest] = React.useState(80);
  const [modalTraining, setmodalTraining] = React.useState(false);
  const [allmodel, setallmodel] = React.useState([]);
  const [prevalgo, setprevalgo] = React.useState([]);
  const [cat, setcat] = React.useState([]);
  const [getLoader, setGetLoader] = React.useState(false);
  const [ann, setAnn] = React.useState([]);
  const [open, setOpen] = React.useState(false);
  const [openn, setOpenn] = React.useState(false);
  const [selected, setselected] = React.useState(0);
  

  const [parameters, setParameters] = React.useState(
    [
    [1, "c", false, "", "none"],
    ["(1,1,0)", "(0, 0, 0, 0)", "", true, true, false, 1, "", "none"],
    [
      "(2,0,0)",
      "(0, 0, 0, 0)",
      "",
      false,
      false,
      true,
      false,
      true,
      true,
      false,
      1,
    ],

    [
      "",
      false,
      "",
      "",
      "estimated",
      "",
      "",
      "",
      false,
      "",
      "none",
    ],
    [null],
    [
      5,32,100,'tanh', 'sigmoid', true, 'glorot_uniform', 'orthogonal', 'zeros', 
      "none", "none", "none", "none", "none", "none", "none", "none", 0.0, 0.0, "none", 
      false, false, false, false, false, 'auto'
  ]
  ]);
  const [parameterslabels, setParameterslabels] = React.useState([
    ["Lags", "Trend", "Seasonal", "Period", "Missing"],

    [
      "Order",
      "Seasonal Order",
      "Trend",
      "Enforce Stationarity",
      "Enforce Invertibility",
      "Concentrate Scale",
      "Trend Offset",
      "Frequency",
      "Missing",
    ],

    [
      "Order",
      "Seasonal Order",
      "Trend",
      "Measurement Error",
      "Time Varying Regression",
      "Mle Regression",
      "Simple Differencing",
      "Enforce Stationarity",
      "Enforce Invertibility",
      "Concentrate Scale",
      "Trend Offset",
    ],

    [
      "Trend",
      "Damped Trend",
      "Seasonal",
      "Seasonal periods",
      "Initialization Method",
      "Initial Level",
      "Initial Trend",
      "Initial Seasonal",
      "Use Boxcox",
      "Frequency",
      "Missing",
    ],

    ["No Paramters"],
    [
      'Epochs','Batch Size','units', 'activation', 'recurrent_activation', 'use_bias', 
      'kernel_initializer', 'recurrent_initializer', 'bias_initializer', 
      'unit_forget_bias', 'kernel_regularizer', 'recurrent_regularizer', 
      'bias_regularizer', 'activity_regularizer', 'kernel_constraint', 
      'recurrent_constraint', 'bias_constraint', 'dropout', 
      'recurrent_dropout', 'seed', 'return_sequences', 'return_state', 
      'go_backwards', 'stateful', 'unroll', 'use_cudnn'
  
  ]]);
  const [links, setlinks] = React.useState([
    "https://www.statsmodels.org/v0.12.2/generated/statsmodels.tsa.ar_model.AR.html",
    "https://www.statsmodels.org/dev/generated/statsmodels.tsa.arima.model.ARIMA.html",
    "https://www.statsmodels.org/dev/generated/statsmodels.tsa.statespace.sarimax.SARIMAX.html",
    "https://www.statsmodels.org/dev/examples/notebooks/generated/exponential_smoothing.html",
    "https://facebook.github.io/prophet/docs/quick_start.html"
  ]);
  const [choosenalgo, setChoosenalgo] = React.useState([]);
  const [showinput, setshowinput] = React.useState([]);
  const [algochoosen, setalgochoosen] = React.useState(false);
  const [valueerror, setvalueerror] = React.useState("");
  const [timeseries, settimeseries] = React.useState(0);
  const [value, setValue] = React.useState("1");
  const tooltip = [
    [
      "{None, int, list[int]}",
      '{"n", "c", "t", "ct"}',
      "bool",
      '{"None","int"}',
      '{"None", "drop","raise"}',
    ],
    [
      "tuple",
      "tuple",
      '{"n","c","t","ct"}',
      "boolean",
      "boolean",
      "boolean",
      "integer",
      "string",
      "string",
    ],

    [
      "tuple",
      "tuple",
      '{"n","c","t","ct"}',
      "boolean",
      "boolean",
      "boolean",
      "boolean",
      "boolean",
      "boolean",
      "boolean",
      "integer",
    ],

    [
      "{“add”, “mul”, “additive”, “multiplicative”, None}",
      "boolean",
      "{“add”, “mul”, “additive”, “multiplicative”, None}",
      "integer",
      '{"None","estimated","heuristic","legacy-heuristic","known"}',
      "float",
      "float",
      "array",
      '{"True", "False", "log", "float"}',
      "string",
      "string",
    ],

    [],
    ["Positive integer","Positive integer","Positive integer","Activation function to use. Default: hyperbolic tangent (tanh). If you pass None, no activation is applied (ie. 'linear' activation: a(x) = x).",
      "Activation function to use for the recurrent step. Default: sigmoid (sigmoid). If you pass None, no activation is applied (ie. 'linear' activation: a(x) = x).",
      "Boolean, (default True)",
      "Initializer for the kernel weights matrix, used for the linear transformation of the inputs. Default: 'glorot_uniform'.",
      "Initializer for the recurrent_kernel weights matrix, used for the linear transformation of the recurrent state.",
      "Initializer for the bias vector",
      "Boolean (default True)",
      "Regularizer function applied to the kernel weights matrix",
      "Regularizer function applied to the recurrent_kernel weights matrix",
      "Regularizer function applied to the bias vector",
      "Regularizer function applied to the output of the layer (its 'activation')",
      "Constraint function applied to the kernel weights matrix",
      "	Constraint function applied to the recurrent_kernel weights matrix.",
      "Constraint function applied to the bias vector",
      "Float between 0 and 1",
      "Float between 0 and 1",
      "Random seed for dropout.",
      "Boolean",
      "Boolean",
      "Boolean",
      "Boolean",
      "Boolean",
      "Whether to use a cuDNN-backed implementation. 'auto' will attempt to use cuDNN when feasible, and will fallback to the default implementation if not."

    ]
  ];

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleClickOpenn = () => {
    setOpenn(true);
  };

  const handleClosee = () => {
    setOpenn(false);
  };
  const handleChangeHybrid = (event, newValue) => {
    setValue(newValue);
  };


  let newArray = [];
  let newparameters = [];
  let change = [];
  let timer;

  //dependentalgo =['lasso','lasso']
  //dependentalgo = ['linear','lasso']

  const handleChange = (event, idx) => {
    //setalgochoosen(true);
    console.log(event,idx)
    setIndex(event.target.value);
    let index = event.target.value;
    const dataArray = Array.from(dependentalgo);
    const chosenalgoarray = Array.from(choosenalgo);
    const show = Array.from(showinput);
    dataArray[idx] = algorithm[index];
    chosenalgoarray[idx] = parameters[index];
    show[idx] = index;
    setDependentAlgo(dataArray);
    setChoosenalgo(chosenalgoarray);
    setshowinput(show);

    // let dataArray =
    //index - e.target.value
    //item to update on index- algorithm[e.target.value]
    // setDependentAlgo(dependentalgo=>[...dependentalgo,algorithm[event.target.value]]);
  };

  const trainhmodel = () => {
    setProgress(0);
    setTrained(false);
    const ProjectID = sessionStorage.getItem("projectID");
    
    if (htest == "" || htest == null || dependentalgo.length == 0) {
      setOpen(true);
    }
     
    else {
      const body = JSON.stringify({
        independent,
        dependent,
        dependentalgo,
        trainsize: test,
        htrainsize:htest,
        ProjectID,
        allmodel,
        ann: 0,
        choosenalgo,
        showinput,
        timeseries: 1,
      });

      setmodalTraining(true);
      const config = {
        onUploadProgress: (progressEvent) => {
        let seconds = 1000    
        timer = setInterval(() => {
          setProgress((prevProgress) => (prevProgress >= 99 ? 99 : prevProgress + 1));
          
        }, seconds)
        
        },
         headers : {
          "Content-Type": "application/json",
        }
      }

      try {
        axios
        .post(`${baseURL}/trainmodel`, body,config)
          .then((response) => response)
          .then((result) => {
            if (result.data.message == "error") {
              console.log("errorr");
              console.log(result.data.algo)
              console.log(algorithmshort[result.data.algo])
              setselected(result.data.algo);
              setTrained(false);
              setmodalTraining(false);
              setProgress(0);
              setvalueerror(result.data.valueerror);
              setOpenn(true);
              
            } else {
              setTrained(true);
              setmodalTraining(false);
              setallmodel(result.data.allmodel);
              clearInterval(timer);
              setProgress(100);
              
            }
          })
          .catch((error) => {
            setmodalTraining(false);
            console.error("Error:", error);
          });
      } catch (error) {
        setmodalTraining(false);
        console.log("error", error);
      }
    }
  };

  const trainmodel = () => {
    setProgress(0);
    setTrained(false);
    const ProjectID = sessionStorage.getItem("projectID");
    
    if (test == "" || test == null || dependentalgo.length == 0) {
      setOpen(true);
    }
     
    else {
      const body = JSON.stringify({
        independent,
        dependent,
        dependentalgo,
        trainsize: test,
        ProjectID,
        allmodel,
        ann: 0,
        choosenalgo,
        showinput,
        timeseries: 1,
      });

      setmodalTraining(true);
      const config = {
        onUploadProgress: (progressEvent) => {
        let seconds = 1000    
        timer = setInterval(() => {
          setProgress((prevProgress) => (prevProgress >= 99 ? 99 : prevProgress + 1));
          
        }, seconds)
        
        },
         headers : {
          "Content-Type": "application/json",
        }
      }

      try {
        axios
        .post(`${baseURL}/trainmodel`, body,config)
          .then((response) => response)
          .then((result) => {
            if (result.data.message == "error") {
              console.log("errorr");
              console.log(result.data.algo)
              console.log(algorithmshort[result.data.algo])
              setselected(result.data.algo);
              setTrained(false);
              setmodalTraining(false);
              setProgress(0);
              setvalueerror(result.data.valueerror);
              setOpenn(true);
              
            } else {
              setTrained(true);
              setmodalTraining(false);
              setallmodel(result.data.allmodel);
              clearInterval(timer);
              setProgress(100);
              
            }
          })
          .catch((error) => {
            setmodalTraining(false);
            console.error("Error:", error);
          });
      } catch (error) {
        setmodalTraining(false);
        console.log("error", error);
      }
    }
  };

  const initializeDependentAlgo = (data) => {
    if (data.prevalgo.length > 0) {
      data.dependent.map((item, i) => {
        newArray.push(algorithm[data.prevalgo[i]]);
        setDependentAlgo(newArray);
      });
    } else {
      data.dependent.map((item, i) => {
        newArray.push("lasso");
        setDependentAlgo(newArray);
      });
    }
  };

  React.useEffect(() => {
    getBuildModel();
  }, []);

  const getBuildModel = () => {
    setGetLoader(true);
    const ProjectID = sessionStorage.getItem("projectID");
    fetch(
      `${baseURL}/getbuildmodel?projectID=${ProjectID}&loaded=${props.loaded}`
    )
      .then((res) => res.json())
      .then((data) => {
        setTest(data.traindata);
        setprevalgo(data.prevalgo);
        initializeDependentAlgo(data);
        setIndependent(data.independent);
        setDependent(data.dependent);
        setunitsin(data.unitsin);
        setunitsde(data.unitsde);
        setCount(data.len_all);
        setcat(data.cat);
        setGetLoader(false);
        setAnn(data.ann);
        setshowinput(data.showinput);
        setChoosenalgo(data.hyperparameters);
        settimeseries(data.timeseries);

        //setIndex(0);
      })
      .catch((err) => {
        setGetLoader(false);
        console.log("err", err);
      });
  };

  const NextStep = () => {
    props.handleNextStep();
  };
  const handleSize = (e) => {
    setTest(e.target.value);
  };

  const handlehSize = (e) => {
    sethTest(e.target.value);
  };

  const handleInput = (event, i, j) => {
    let change = choosenalgo.slice();
    let arrayy = change[i].slice();
    arrayy[j] = event.target.value;
    change[i] = arrayy.slice();
    setChoosenalgo(change);

    //change[i][j] = event.target.value;
    //setchoosenalgo(chosenalgoarray);
  };
  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{ color: "red", fontSize: "13px" }}
        >
          {"Train Data % Required"}
        </DialogTitle>
      </Dialog>

      <Dialog
        open={openn}
        onClose={handleClosee}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{ color: "red", fontSize: "13px" }}
        >
          <Typography sx={{ fontSize: 15 }}>
            Parameter Input Wrong for Algorithm {algorithmshort[selected]}{" "}
          </Typography>
          <Typography sx={{ fontSize: 13, color: "black", marginTop: 2 }}>
            {valueerror}
          </Typography>
          <Typography
            sx={{ fontSize: 13, color: Projectcolors.primary, marginTop: 2 }}
          >
            Know more about {algorithmshort[selected]} Parameters:{" "}
            <a   href={links[selected]}>
              Click Here
            </a>
          </Typography>
        </DialogTitle>
      </Dialog>
      {timeseries ? (
  <Box
    component={Paper}
    elevation={0}
    sx={{
      height: "820px",
      p: "24px",
      m: "2px 0",
      borderRadius: "22px",
      border: "2px solid #0078c9",
      background:
        "linear-gradient(to bottom,#ffffff,#fbfcff)",
      boxShadow: "0 8px 25px rgba(0,120,201,.08)",
    }}
  >
   <TabContext value={value}>
  {/* TOP TAB */}
  <Box
    sx={{
      display: "flex",
      justifyContent: "center",
      mb: 2,
      mt: 1,
    }}
  >
    <TabList
      onChange={handleChangeHybrid}
      TabIndicatorProps={{
        style: {
          display: "none",
        },
      }}
      sx={{
        bgcolor: "#f5f9fd",
        p: "6px",
        borderRadius: "16px",
        border: "1px solid #d9e9f7",

        "& .MuiTabs-flexContainer": {
          gap: "10px",
        },

        "& .MuiTab-root": {
          textTransform: "none",
          fontSize: "13px",
          fontWeight: 600,
          minHeight: "42px",
          minWidth: "220px",
          borderRadius: "12px",
          color: "#555",
          transition: ".25s",
        },

        "& .MuiTab-root:hover": {
          bgcolor: "#f5f9fd",
          color: "#0078c9",
        },

        "& .Mui-selected": {
          bgcolor: "#0078c9",
          color: "#fff !important",
          boxShadow: "0 4px 12px rgba(0,120,201,.25)",
        },
      }}
    >
      <Tab
        label="Classic Time Series"
        value="1"
      />

      <Tab
        label="Hybrid Time Series"
        value="2"
      />
    </TabList>
  </Box>


      {/* CLASSIC TAB */}
      <TabPanel value="1" sx={{ p: 0 }}>
        {/* TRAIN DATA */}
        <Box
          sx={{
            width: 380,
            display: "flex",
            alignItems: "center",
            mb: 5,
            ml: 4,
          }}
        >
          <Typography
            sx={{
              fontSize: "13px",
              fontWeight: 600,
              mr: 1,
            }}
          >
            Train Data %
          </Typography>

          <OutlinedInput
            onChange={handleSize}
            defaultValue={test}
            size="small"
            sx={{
              width: 140,
              height: 40,
              fontSize: "14px",

              "& .MuiOutlinedInput-notchedOutline":
                {
                  borderColor: "#0078c9",
                },

              "&:hover .MuiOutlinedInput-notchedOutline":
                {
                  borderColor: "#9e0b22",
                },

              "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                {
                  borderColor: "#0078c9",
                },
            }}
          />
        </Box>

        {/* BODY */}
        <Box
          sx={{
            mt: 2,
            px: 3,
            display: "flex",
            gap: 2,
            alignItems: "stretch",
            justifyContent: "space-between",
            width: "100%",
            minHeight: "450px",
          }}
        >
          {/* Independent */}
          <Paper
            elevation={6}
            sx={{
              flex: 1.2,
              borderRadius: "22px",
              border: "1px solid #d9e9f7",
              position: "relative",
              minWidth: 300,
            }}
          >
            <Box
              sx={{
                position: "absolute",
                top: -16,
                left: 20,
                px: 2,
                py: 0.8,
                borderRadius: "20px",
                background: "#0078c9",
                color: "#fff",
                fontWeight: 600,
                fontSize: 15,
              }}
            >
              Independent Variables
            </Box>

            <Box
              sx={{
                p: 3,
                pt: 6,
                height: 420,
                overflowY: "auto",
              }}
            >
              {independent.map((item, i) => (
                <Box sx={{ mb: 2 }}>
                  <Typography sx={{ fontSize: 12 }}>
                    {item} ({unitsin[i]})
                  </Typography>

                  <img
                    src={Arrow}
                    alt="arrow"
                    style={{
                      width: "100%",
                      height: "28px",
                    }}
                  />
                </Box>
              ))}
            </Box>
          </Paper>

          {/* MODEL */}
          <Paper
            elevation={8}
            sx={{
              width: 320,
              borderRadius: "24px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              border: "1px solid #d9e9f7",
            }}
          >
            <Typography
              sx={{
                fontWeight: 700,
                fontSize: 16,
                mb: 4,
                color: "#0078c9",
              }}
            >
              SelexMB Training Model
            </Typography>

            <img
              src={model}
              alt="model"
              style={{
                width: "80%",
                objectFit: "contain",
              }}
            />
          </Paper>

          {/* DEPENDENT */}
          <Paper
            elevation={6}
            sx={{
              flex: 1.5,
              borderRadius: "22px",
              border: "1px solid #d9e9f7",
              position: "relative",
              minWidth: 360,
            }}
          >
            <Box
              sx={{
                position: "absolute",
                top: -16,
                left: 20,
                px: 2,
                py: 0.8,
                borderRadius: "20px",
                background: "#0078c9",
                color: "#fff",
                fontWeight: 600,
              }}
            >
              Dependent Variables
            </Box>

            <Box
              sx={{
                p: 3,
                pt: 6,
                height: 420,
                overflowY: "auto",
              }}
            >
              {dependent.map((item, i) => (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 3,
                  }}
                >
                  <Box width="45%">
                    <Typography
                      sx={{ fontSize: 12 }}
                    >
                      {item} ({unitsde[i]})
                    </Typography>

                    <img
                      src={Arrow}
                      alt="arrow"
                      style={{
                        width: "100%",
                        height: "28px",
                      }}
                    />
                  </Box>

                  <Box width="45%">
                    <Typography
                      sx={{
                        fontSize: 10,
                      }}
                    >
                      Select Algorithm
                    </Typography>

                    <FormControl fullWidth>
                      <Select
                        size="small"
                        defaultValue={prevalgo[i]}
                        onChange={(e) =>
                          handleChange(e, i)
                        }
                        sx={{
                          fontSize: "12px",
                          borderRadius: "10px",

                          "& .MuiOutlinedInput-notchedOutline":
                            {
                              borderColor:
                                "#0078c9",
                            },
                        }}
                      >
                        <MenuItem value={0}>
                          AR
                        </MenuItem>

                        <MenuItem value={1}>
                          ARIMA
                        </MenuItem>

                        <MenuItem value={2}>
                          SARIMAX
                        </MenuItem>

                        <MenuItem value={3}>
                          ES
                        </MenuItem>

                        <MenuItem value={4}>
                          PROPHET
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </Box>
                </Box>
              ))}
            </Box>
          </Paper>

          {/* HYPERPARAMETERS */}
          <Paper
            elevation={6}
            sx={{
              width: 360,
              borderRadius: "22px",
              border: "1px solid #d9e9f7",
              position: "relative",
            }}
          >
            <Box
              sx={{
                position: "absolute",
                top: -16,
                left: 20,
                px: 2,
                py: 0.8,
                borderRadius: "20px",
                background: "#0078c9",
                color: "#fff",
                fontWeight: 600,
              }}
            >
              Hyperparameter Tuning
            </Box>

            <Box
              sx={{
                p: 3,
                pt: 6,
                height: 420,
                overflowY: "auto",
              }}
            >
              {choosenalgo.map((item, i) => (
                <Box sx={{ mb: 3 }}>
                  <Typography
                    sx={{
                      fontSize: 12,
                      fontWeight: 600,
                      color: "#0078c9",
                      mb: 2,
                    }}
                  >
                    {dependent[i]}{" "}
                    {
                      algorithmshort[
                        showinput[i]
                      ]
                    }{" "}
                    Parameters
                  </Typography>

                  {algorithmshort[
                    showinput[i]
                  ] !== "PROPHET" ? (
                    item.map((value, j) => (
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent:
                            "space-between",
                          mb: 1.5,
                          p: 1,
                          borderRadius: "12px",

                          "&:hover": {
                            bgcolor:
                              "#f8fbff",
                          },
                        }}
                      >
                        <Typography
                          sx={{
                            width: "45%",
                            fontSize: "12px",
                          }}
                        >
                          {
                            parameterslabels[
                              showinput[i]
                            ][j]
                          }
                        </Typography>

                        <Box
                          sx={{
                            display: "flex",
                            alignItems:
                              "center",
                            gap: 0.5,
                          }}
                        >
                          <OutlinedInput
                            placeholder="None"
                            value={value}
                            onChange={(e) =>
                              handleInput(
                                e,
                                i,
                                j
                              )
                            }
                            size="small"
                            sx={{
                              width: "120px",
                              height: "36px",
                              fontSize:
                                "12px",

                              borderRadius:
                                "12px",

                              "& .MuiOutlinedInput-notchedOutline":
                                {
                                  borderColor:
                                    "#0078c9",
                                },

                              "&:hover .MuiOutlinedInput-notchedOutline":
                                {
                                  borderColor:
                                    "#9e0b22",
                                },

                              "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                {
                                  borderColor:
                                    "#0078c9",
                                },
                            }}
                          />

                          <Tooltip
                            arrow
                            title={
                              <Typography
                                sx={{
                                  fontSize:
                                    "11px",
                                }}
                              >
                                {
                                  tooltip[
                                    showinput[
                                      i
                                    ]
                                  ][j]
                                }
                              </Typography>
                            }
                          >
                            <IconButton
                              size="small"
                              sx={{
                                bgcolor:
                                  "#f5f8fc",
                                border:
                                  "1px solid #d7e6f2",

                                "&:hover":
                                  {
                                    bgcolor:
                                      "#0078c9",
                                    color:
                                      "#fff",
                                  },
                              }}
                            >
                              <InfoIcon
                                sx={{
                                  fontSize: 16,
                                }}
                              />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      </Box>
                    ))
                  ) : (
                    <Typography
                      sx={{
                        fontSize: 12,
                      }}
                    >
                      No hyperparameters
                      for Prophet Algorithm
                    </Typography>
                  )}
                </Box>
              ))}
            </Box>
          </Paper>
        </Box>

        {/* FOOTER */}
        <Box
          sx={{
            display: "flex",
            justifyContent:
              "space-between",
            mt: 4,
            ml: 4,
            mr: 3,
          }}
        >
          <Box
            sx={{
              display: "flex",
              gap: 4,
            }}
          >
            <Typography fontSize={12}>
              Count: {count}
            </Typography>

            <Typography fontSize={12}>
              Independent:
              {independent.length}
            </Typography>

            <Typography fontSize={12}>
              Dependent:
              {dependent.length}
            </Typography>
          </Box>

          <Box>
            <Button
              onClick={trainmodel}
              variant="contained"
              sx={{
                mr: 2,
                width: "120px",
                height: "42px",
                minWidth: "120px",
                fontSize: "12px",
                fontWeight: 600,
                borderRadius: "12px",
                backgroundColor:
                  Projectcolors.primary,

                "&:hover": {
                  backgroundColor:
                    "#9e0b22",
                },
              }}
            >
              Train
            </Button>

            <Button
              onClick={NextStep}
              variant="contained"
              sx={{
                width: "120px",
                height: "42px",
                minWidth: "120px",
                fontSize: "12px",
                borderRadius: "12px",
                backgroundColor:
                  Projectcolors.primary,

                "&:hover": {
                  backgroundColor:
                    "#9e0b22",
                },
              }}
            >
              <ChevronRightIcon />
            </Button>
          </Box>
        </Box>

        <Box sx={{ ml: 4 }}>
          {trained && (
            <Alert
              sx={{
                mt: 2,
                width: "30%",
                fontSize: 12,
              }}
              severity="success"
            >
              Model Trained Successfully
            </Alert>
          )}

          {(trained || modalTraining) && (
            <Box mt={2}>
              <LinearProgressWithLabel
                value={
                  trained
                    ? 100
                    : progress
                }
              />
            </Box>
          )}
        </Box>
      </TabPanel>

      {/* HYBRID TAB */}
      {/* HYBRID TAB */}
<TabPanel value="2" sx={{ p: 0 }}>
  {/* TRAIN DATA */}
  <Box
    sx={{
      width: 380,
      display: "flex",
      alignItems: "center",
      mb: 5,
      ml: 4,
    }}
  >
    <Typography
      sx={{
        fontSize: "13px",
        fontWeight: 600,
        mr: 1,
      }}
    >
      Train Data %
    </Typography>

    <OutlinedInput
      onChange={handlehSize}
      defaultValue={htest}
      size="small"
      sx={{
        width: 140,
        height: 40,
        fontSize: "14px",

        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: "#0078c9",
        },

        "&:hover .MuiOutlinedInput-notchedOutline":
          {
            borderColor: "#9e0b22",
          },

        "&.Mui-focused .MuiOutlinedInput-notchedOutline":
          {
            borderColor: "#0078c9",
          },
      }}
    />
  </Box>

  {/* BODY */}
  <Box
    sx={{
      mt: 2,
      px: 3,
      display: "flex",
      gap: 2,
      alignItems: "stretch",
      justifyContent: "space-between",
      width: "100%",
      minHeight: "450px",
    }}
  >
    {/* Independent */}
    <Paper
      elevation={6}
      sx={{
        flex: 1.2,
        borderRadius: "22px",
        border: "1px solid #d9e9f7",
        position: "relative",
        minWidth: 300,
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: -16,
          left: 20,
          px: 2,
          py: .8,
          borderRadius: "20px",
          background: "#0078c9",
          color: "#fff",
          fontWeight: 600,
        }}
      >
        Independent Variables
      </Box>

      <Box
        sx={{
          p: 3,
          pt: 6,
          height: 420,
          overflowY: "auto",
        }}
      >
        {independent.map((item,i)=>(
          <Box sx={{mb:2}}>
            <Typography sx={{fontSize:12}}>
              {item} ({unitsin[i]})
            </Typography>

            <img
              src={Arrow}
              alt="arrow"
              style={{
                width:"100%",
                height:"28px"
              }}
            />
          </Box>
        ))}
      </Box>
    </Paper>


    {/* MODEL */}
    <Paper
      elevation={8}
      sx={{
        width:320,
        borderRadius:"24px",
        display:"flex",
        flexDirection:"column",
        justifyContent:"center",
        alignItems:"center",
        border:"1px solid #d9e9f7"
      }}
    >
      <Typography
        sx={{
          fontWeight:700,
          fontSize:16,
          mb:4,
          color:"#0078c9"
        }}
      >
        Hybrid Time Series Model
      </Typography>

      <img
        src={model}
        alt="model"
        style={{
          width:"80%",
          objectFit:"contain"
        }}
      />
    </Paper>


    {/* DEPENDENT */}
    <Paper
      elevation={6}
      sx={{
        flex:1.5,
        borderRadius:"22px",
        border:"1px solid #d9e9f7",
        position:"relative",
        minWidth:360
      }}
    >
      <Box
        sx={{
          position:"absolute",
          top:-16,
          left:20,
          px:2,
          py:.8,
          borderRadius:"20px",
          background:"#0078c9",
          color:"#fff",
          fontWeight:600
        }}
      >
        Dependent Variables
      </Box>

      <Box
        sx={{
          p:3,
          pt:6,
          height:420,
          overflowY:"auto"
        }}
      >
        {dependent.map((item,i)=>(
          <Box
            sx={{
              display:"flex",
              justifyContent:"space-between",
              alignItems:"center",
              mb:3
            }}
          >
            <Box width="45%">
              <Typography sx={{fontSize:12}}>
                {item} ({unitsde[i]})
              </Typography>

              <img
                src={Arrow}
                alt="arrow"
                style={{
                  width:"100%",
                  height:"28px"
                }}
              />
            </Box>

            <Box width="45%">
              <Typography
                sx={{fontSize:10}}
              >
                Select Algorithm
              </Typography>

              <FormControl fullWidth>
                <Select
                  size="small"
                  defaultValue={5}
                  sx={{
                    fontSize:"12px",
                    borderRadius:"10px",

                    "& .MuiOutlinedInput-notchedOutline":
                    {
                      borderColor:"#0078c9"
                    }
                  }}
                >
                  <MenuItem value={5}>
                    CNN LSTM
                  </MenuItem>
                </Select>
              </FormControl>
            </Box>
          </Box>
        ))}
      </Box>
    </Paper>


    {/* HYPERPARAMETERS */}
    <Paper
      elevation={6}
      sx={{
        width:360,
        borderRadius:"22px",
        border:"1px solid #d9e9f7",
        position:"relative"
      }}
    >
      <Box
        sx={{
          position:"absolute",
          top:-16,
          left:20,
          px:2,
          py:.8,
          borderRadius:"20px",
          background:"#0078c9",
          color:"#fff",
          fontWeight:600
        }}
      >
        Hyperparameter Tuning
      </Box>

      <Box
        sx={{
          p:3,
          pt:6,
          height:420,
          overflowY:"auto"
        }}
      >
        {choosenalgo.map((item,i)=>
          item.map((value,j)=>(

            <Box
              sx={{
                display:"flex",
                alignItems:"center",
                justifyContent:"space-between",
                mb:1.5,
                p:1,
                borderRadius:"12px",

                "&:hover":{
                  bgcolor:"#f8fbff"
                }
              }}
            >
              <Typography
                sx={{
                  width:"45%",
                  fontSize:"12px"
                }}
              >
                {parameterslabels[showinput[i]][j]}
              </Typography>

              <Box
                sx={{
                  display:"flex",
                  alignItems:"center",
                  gap:.5
                }}
              >
                <OutlinedInput
                  placeholder="None"
                  value={value}
                  onChange={(e)=>
                    handleInput(e,i,j)
                  }
                  size="small"
                  sx={{
                    width:"120px",
                    height:"36px",
                    fontSize:"12px",

                    "& .MuiOutlinedInput-notchedOutline":
                    {
                      borderColor:"#0078c9"
                    }
                  }}
                />

                <Tooltip
                  arrow
                  title={
                    <Typography
                      sx={{
                        fontSize:"11px"
                      }}
                    >
                      {tooltip[showinput[i]][j]}
                    </Typography>
                  }
                >
                  <IconButton
                    size="small"
                    sx={{
                      bgcolor:"#f5f8fc",
                      border:"1px solid #d7e6f2",

                      "&:hover":{
                        bgcolor:"#0078c9",
                        color:"#fff"
                      }
                    }}
                  >
                    <InfoIcon
                      sx={{
                        fontSize:16
                      }}
                    />
                  </IconButton>
                </Tooltip>
              </Box>
            </Box>

          ))
        )}
      </Box>
    </Paper>
  </Box>


  {/* FOOTER */}
  <Box
    sx={{
      display:"flex",
      justifyContent:"space-between",
      mt:4,
      ml:4,
      mr:3
    }}
  >
    <Box
      sx={{
        display:"flex",
        gap:4
      }}
    >
      <Typography fontSize={12}>
        Count: {count}
      </Typography>

      <Typography fontSize={12}>
        Independent:
        {independent.length}
      </Typography>

      <Typography fontSize={12}>
        Dependent:
        {dependent.length}
      </Typography>
    </Box>

    <Box>
      <Button
        onClick={trainhmodel}
        variant="contained"
        sx={{
          mr:2,
          width:"120px",
          height:"42px",
          borderRadius:"12px",
          fontSize: "12px",
          backgroundColor:
          Projectcolors.primary,

          "&:hover":{
            backgroundColor:"#9e0b22"
          }
        }}
      >
        Train
      </Button>

      <Button
        onClick={NextStep}
        variant="contained"
        sx={{
          width:"120px",
          height:"42px",
          borderRadius:"12px",
          fontSize: "12px",
          backgroundColor:
          Projectcolors.primary,

          "&:hover":{
            backgroundColor:"#9e0b22"
          }
        }}
      >
        <ChevronRightIcon/>
      </Button>
    </Box>
  </Box>
   <Box sx={{ ml: 4 }}>
          {trained && (
            <Alert
              sx={{
                mt: 2,
                width: "30%",
                fontSize: 12,
              }}
              severity="success"
            >
              Model Trained Successfully
            </Alert>
          )}

          {(trained || modalTraining) && (
            <Box mt={2}>
              <LinearProgressWithLabel
                value={
                  trained
                    ? 100
                    : progress
                }
              />
            </Box>
          )}
        </Box>
</TabPanel>
    </TabContext>
  </Box> ): (
        <div>
            <Box
  component={Paper}
  elevation={0}
  sx={{
    height: "740px",
    p: 3,
    m: "2px 0",
    borderRadius: "24px",
    border: "2px solid #0078c9",
    background:
      "linear-gradient(to bottom,#ffffff,#fbfcff)",
    boxShadow:
      "0 8px 25px rgba(0,120,201,.08)",
  }}
>
            <div style={{ margin: "auto", width: "100%", textAlign: "center" }}>
              <Typography
                sx={{
                  fontSize: 16,
                  color: Projectcolors.primary,
                  marginTop: 2,
                }}
              >
                Data Doesn't Include Time Series . Try MLOps and Deep Learning Algorithms.
              </Typography>{" "}
            </div>
          </Box>
        </div>
      )}

      {getLoader ? <GlobalLoader /> : null}
    </div>
  );
}

export default Forecasting;
